import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Table from "@mui/material/Table";
import TextField from '@mui/material/TextField';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MainLayout from "../components/layout/MainLayout";
import { Modal, Card, Typography, Button, Container, Stack } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReportIcon from '@mui/icons-material/Report';
import CircularProgress from '@mui/material/CircularProgress';
// KaTeX dependency
import "katex/dist/katex.css";
// Quill dependency
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// MathQuill dependency
import "./jquery";
import "@edtr-io/mathquill/build/mathquill.js";
import "@edtr-io/mathquill/build/mathquill.css";
// mathquill4quill include
import "mathquill4quill/mathquill4quill.css";
import RichHtml from '../components/editor/RichHtml';
import { useMathQuillInit } from '../components/editor/useMathQuillInit';

// API
import { fetchInformationAsync, deleteInformationAsync, updateInformationAsync, createInformationAsync } from '../redux/reducer/information/informationSlice';
import katex from "katex";
import { deleteFile, uploadToFileStorage } from '../utils/cloudinary';
window.katex = katex;

const Informations = () => {
  const { appId } = useParams();
  const dispatch = useDispatch();

  const informations = useSelector((state) => state.information.list);
  const loading = useSelector((state) => state.information.loading);

  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedInformation, setSelectedInformation] = useState(null);
  const [title, setTitle] = useState('');
  const [special, setSpecial] = useState(false);
  const [saved, setSaved] = useState(false);
  const [informationBody, setInformationBody] = useState('');

  const initMathQuill = useMathQuillInit();
  const quillFormats = useMemo(() => (
    ['bold', 'italic', 'underline', 'strike', 'script', 'header', 'color', 'background', 'blockquote', 'list', 'bullet', 'link', 'image', 'video', 'code-block', 'formula']
  ), []);
  const quillModules = useMemo(() => ({
    formula: true,
    toolbar: [
      ["video", "bold", "italic", "strike", "underline", "formula", "image", "color", "code-block"],
      [{ script: "sub" }, { script: "super" }],
      ["link"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      ['blockquote'],
      [{ list: "ordered" }, { list: "bullet" }],
      ['clean']
    ]
  }), []);

  const handleOpen = () => {
    setOpen(true);
    setSaved(false);
  };

  const handleInformationChange = (newContent) => {
    setInformationBody(newContent);
  };

  const handleClose = () => {
    setOpen(false);
    setSaved(false);
    setTitle('');
    setInformationBody('');
    setSelectedImage(null);
  };
  const openEditModal = (information) => {
    setIsEditModalOpen(true);
    setSelectedInformation(information)
  };
  // Function to close the edit modal
  const closeEditModal = () => {
    setSelectedInformation(null)
    setIsEditModalOpen(false);
  };
  const handleOpenDeleteModal = (information) => {
    setSelectedInformation(information);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };


  useEffect(() => {
    dispatch(fetchInformationAsync(appId));
  }, [dispatch, appId]);

  const handleAdd = async (e) => {
    e.preventDefault()

    if (!(title && informationBody)) {
      alert('Please input the required fields');
      return;
    }
    if (selectedImage) {

      try {
        const data = await uploadToFileStorage(selectedImage, {
          folder: `informations`,
        });
        const Image = data.url;
        const informationData = {
          title,
          content: informationBody,
          image: Image,
          is_special: special,
        };

        dispatch(createInformationAsync(appId, informationData))
          .then(() => {
            setSaved(true);
            dispatch(fetchInformationAsync(appId));
          });
      } catch (error) {
        console.error(error);
      }
    }
    else {
      const informationData = {
        title,
        content: informationBody,
        is_special: special,
      };

      dispatch(createInformationAsync(appId, informationData))
        .then(() => {
          setSaved(true);
          dispatch(fetchInformationAsync(appId));
        });

      setSaved(false);
      setTitle('');
      setInformationBody('');
      setSelectedImage(null);
    }
  }

  //Edit Topic
  const handleUpdateInformation = async (e) => {
    e.preventDefault();
    if (selectedInformation) {
      if (selectedImage) {
        try {
          const data = await uploadToFileStorage(selectedImage, {
            folder: `informations`,
          });

          // Handle the response from Cloudinary after successful upload
          selectedInformation.image = data.url;
          dispatch(updateInformationAsync({ appId, informationId: selectedInformation._id, informationData: selectedInformation }))
            .then((updatedInformation) => {
              if (updatedInformation) {
                // Update the 'notes' state variable with the updated note data
                setSelectedInformation(updatedInformation);
                setSaved(true);

                dispatch(fetchInformationAsync(appId));
                setSelectedImage(null)
              }
            }).catch((error) => {
              console.error(error);
              // Handle error if necessary
            });

        } catch (err) {
          console.error(err);
        }
      } else {
        dispatch(updateInformationAsync({ appId, informationId: selectedInformation._id, informationData: selectedInformation }))
          .then((updatedInformation) => {
            if (updatedInformation) {
              // Update the 'notes' state variable with the updated note data
              setSelectedInformation(updatedInformation);
              dispatch(fetchInformationAsync(appId));
              setSaved(true);
              setSelectedImage(null)
            }
          }).catch((error) => {
            console.error(error);
            // Handle error if necessary
          });

      }

      dispatch(fetchInformationAsync(appId));
    }
    dispatch(fetchInformationAsync(appId));
  }

  const handleDeleteInformation = () => {
    if (selectedInformation) {
      
      dispatch(deleteInformationAsync({ appId, informationId: selectedInformation }));
      console.log(`deleted ${selectedInformation}`);
      if (selectedInformation.image) {
        // Optionally, delete the image from Cloudinary if needed
        // You would need to store the public_id when uploading to do this
        const publicId = selectedInformation.image.split('/').pop().split('.')[0];
        console.log(`Deleting file with public ID: ${publicId}`);
        deleteFile(publicId, { folder: `informations` });
      }
      dispatch(fetchInformationAsync(appId));
      handleCloseDeleteModal();
    }
    dispatch(fetchInformationAsync(appId));
  };
  if (!informations) {
    return <Box>Loading...</Box>;
  }

  return (
    <MainLayout>
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Box>
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                sx={{
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Informations
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Manage information content and announcements
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpen}
              sx={{
                borderRadius: 2,
                px: 3,
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                },
              }}
            >
              Add Information
            </Button>
          </Stack>
        </Box>
        <Modal open={open} onClose={handleClose}>
          <Box style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: 600,
            maxHeight: '90vh',
            backgroundColor: 'white',
            borderRadius: 8,
            padding: 16,
            overflow: 'auto'
          }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Create Information</Typography>
            <TextField label="Title" name="year" fullWidth margin="normal" value={title} onChange={(e) => setTitle(e.target.value)} />
            <ReactQuill
              ref={initMathQuill}
              id="editor"
              required
              margin="normal"
              fullWidth
              style={{ minHeight: 200, maxHeight: 400, overflow: 'auto', marginBottom: '1rem' }}
              modules={quillModules}
              formats={quillFormats}
              value={informationBody}
              onChange={handleInformationChange}
              placeholder="Enter Information"
              theme="snow"
            />
            <input type="file" accept="image/*,video/*"
              style={{ margin: "0.8rem" }}
              onChange={handleImageChange} />
            {/**is Special? */}
            <Box>
              <label>Is Special:</label>
              <input
                type="checkbox"
                checked={special}
                onChange={(e) => setSpecial(e.target.checked)}
              />
            </Box>
            <Box style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "center", paddingBottom: "1rem" }}>
              <Button variant="contained" style={{ background: "#540a61" }} onClick={handleAdd}>
                {loading ? 'Saving...' : saved ? 'Saved Successfully' : 'Save'}
              </Button>
              <Button variant='contained' onClick={handleClose} style={{ background: "red" }}>Cancel</Button>
            </Box>
          </Box>
        </Modal>

        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow style={{ borderBottom: "1px solid #8a898f" }}>
                  <TableCell>S/N</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Information</TableCell>
                  <TableCell>File</TableCell>
                  <TableCell>Special</TableCell>
                  <TableCell colSpan="2">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <CircularProgress /> {/* Display loader while fetching data */}
                    </TableCell>
                  </TableRow>
                ) : (
                  informations.map((information, index) => (
                    <TableRow key={information._id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{information.title}</TableCell>
                      <TableCell><RichHtml html={information.content} /></TableCell>
                      <TableCell><img src={information.image} alt="Information" style={{ height: "70px", width: "70px", borderRadius: "50%" }} /></TableCell>
                      <TableCell>{information.is_special ? 'Special' : 'Not Special'}</TableCell>
                      <TableCell>
                        <Button variant='contained' style={{ background: "blue" }} onClick={() => openEditModal(information)}>
                          <EditCalendarIcon background="blue" />
                        </Button>&nbsp;
                        <Button variant='contained' style={{ background: "red" }} onClick={() => handleOpenDeleteModal(information._id)}>
                          <DeleteForeverIcon background="red" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        {/**Edit */}
        {selectedInformation && (
          <Modal open={isEditModalOpen} onClose={closeEditModal}>
            <Box style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90%',
              maxWidth: 600,
              maxHeight: '90vh',
              backgroundColor: 'white',
              borderRadius: 8,
              padding: 16,
              overflow: 'auto'
            }}>
              <Typography variant="h6" style={{ marginBottom: "0.5rem" }}>Edit Information</Typography>
              <TextField
                value={selectedInformation.title}
                label="Title"
                margin="normal"
                fullWidth
                onChange={(e) => setSelectedInformation({ ...selectedInformation, title: e.target.value })}
              />
              <ReactQuill
                ref={initMathQuill}
                id="editor"
                required
                margin="normal"
                fullWidth
                style={{ minHeight: 200, maxHeight: 400, overflow: 'auto', marginBottom: '1rem' }}
                modules={quillModules}
                formats={quillFormats}
                value={selectedInformation.content}
                onChange={(content) => setSelectedInformation({ ...selectedInformation, content })}
                placeholder="Enter Information"
                theme="snow"
              />
              <Box>
                <img src={selectedInformation.image} alt="Information" style={{ borderRadius: "50%", width: 100, height: 100 }} />
                <input type="file" accept="image/*" style={{ margin: "0.8rem" }} onChange={handleImageChange} />
              </Box>
              <Box style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "center", margin: "1rem" }}>
                <Button variant="contained" style={{ background: "#540a61" }} onClick={handleUpdateInformation}>
                  {loading ? 'Saving...' : saved ? 'Saved Successfully' : 'Update'}
                </Button>
                <Button variant="contained" style={{ background: "red", marginLeft: "1rem" }} onClick={closeEditModal}>
                  Cancel
                </Button>
              </Box>
            </Box>
          </Modal>
        )}

        {/**Delete Modal */}
        <Modal
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          aria-labelledby="delete-confirmation-modal"
          aria-describedby="delete-confirmation-modal-description"
        >
          <Box style={{
            position: 'absolute',
            top: '50%', left: '50%',
            transform: 'Translate(-50%, -50%)',
            width: 400,
            backgroundColor: 'white',
            borderRadius: 8, padding: 16
          }}>
            <Box align="center">
              <ReportIcon />
              <Typography fontSize="16px" fontWeight="600" id="delete-confirmation-modal-description">
                Are you sure you want to delete this Information?
              </Typography>
            </Box>
            <Box style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "center", margin: "1rem" }}>
              <Button variant='contained' onClick={handleDeleteInformation}>Yes,Delete</Button>
              <Button variant='contained' color='secondary' onClick={handleCloseDeleteModal}>Cancel</Button>
            </Box>
          </Box>
        </Modal>


      </Container>
    </MainLayout>
  )
}

export default Informations